import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=f1cb334c&scoped=true&"
import script from "./basicSetting.vue?vue&type=script&lang=ts&"
export * from "./basicSetting.vue?vue&type=script&lang=ts&"
import style0 from "./basicSetting.vue?vue&type=style&index=0&id=f1cb334c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cb334c",
  null
  
)

export default component.exports